module Environments {
    module.controller("NewEnvironmentController", [
        "$scope",
        "EnvironmentsService",
        function ($scope, environmentsService) {
            var existingNew = _.find($scope.environments, function (e: any) { return e.isNew; });

            // Only allow one new environment at a time.
            if (existingNew) {
                $scope.environment = existingNew;
            } else {
                $scope.environment = environmentsService.createTemporaryEnv();
                $scope.environments.push($scope.environment);
            }
        }
    ]);
}